(function () {
  'use strict';

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function initCompare(section) {
    var compare = section.querySelector('[data-lp-bas-compare]');
    var divider = section.querySelector('[data-lp-bas-divider]');
    var beforeEl = section.querySelector('.lp-bas__compare__before');
    var afterEl = section.querySelector('.lp-bas__compare__after');
    var afterLabel = section.querySelector('[data-lp-bas-after-label]');

    if (!compare || !divider || !beforeEl || !afterEl) return;
    if (divider._lpBasInit) return;

    divider._lpBasInit = true;

    var isDragging = false;

    function moveSlider(clientX) {
      var rect = compare.getBoundingClientRect();
      var offset = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (offset / rect.width) * 100;

      divider.style.left = pct + '%';
      beforeEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      afterEl.style.clipPath = 'inset(0 0 0 ' + pct + '%)';

      if (afterLabel) {
        afterLabel.style.left = 'calc(' + pct + '% + 20px)';
        afterLabel.style.opacity = pct > 90 ? '0' : '1';
      }
    }

    function resetMobile() {
      beforeEl.style.clipPath = '';
      afterEl.style.clipPath = '';
      divider.style.left = '';
    }

    function onStart(e) {
      if (isMobile()) return;
      isDragging = true;
      if (e.cancelable) e.preventDefault();
    }

    function onStop() {
      isDragging = false;
    }

    function onMouseMove(e) {
      if (isDragging) moveSlider(e.clientX);
    }

    function onTouchMove(e) {
      if (isDragging && e.touches[0]) {
        moveSlider(e.touches[0].clientX);
      }
    }

    divider.addEventListener('mousedown', onStart);
    divider.addEventListener('touchstart', onStart, { passive: false });

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onStop);
    window.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('touchend', onStop);

    function initPosition() {
      if (isMobile()) {
        resetMobile();
      } else {
        var rect = compare.getBoundingClientRect();
        moveSlider(rect.left + rect.width * 0.5);
      }
    }

    requestAnimationFrame(initPosition);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initPosition, 150);
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="lp-before-after-slider"]')
      .forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="lp-before-after-slider"]');
    if (section) initCompare(section);
  });
})();